import gql from 'graphql-tag';
import { notification } from './fragments';

export const GET_NOTIFICATIONS = gql`
  ${notification}
  query GetNotifications($data: GetNotificationsInput!) {
    getNotifications(data: $data) {
      ... on GetNotifications {
        message
        version
        notifications {
          ...notification
        }
        paginationInfo {
          currentPage
          totalPages
          nextPage
          prevPage
          totalRecords
          totalReturnedRecords
          startIndex
          endIndex
        }
      }
      ... on Error {
        errorCode
        message
      }
    }
  }
`;

export const GET_UNREAD_COUNT = gql`
  query GetUnreadCount {
    getUnreadCount {
      ... on GetUnreadCount {
        message
        version
        count
        countByPriority {
          urgent
          high
          normal
          low
        }
      }
      ... on Error {
        errorCode
        message
      }
    }
  }
`;
